import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "cookie-notice-ack-v1";

/**
 * Dezenter, einmaliger Cookie-Hinweis (DSGVO-Transparenz). Die Web-App setzt
 * ausschließlich technisch notwendige Session-Cookies – kein Tracking, kein
 * Opt-in nötig. Das schmale Band unten erklärt das transparent und verlinkt die
 * Datenschutzerklärung. Die Bestätigung wird lokal (versionierter Key)
 * gespeichert, sodass der Hinweis nicht erneut erscheint.
 */
export default function CookieNotice() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) !== "1") {
        setVisible(true);
      }
    } catch {
      // Privater Modus o. Ä.: Hinweis lieber zeigen als verschlucken.
      setVisible(true);
    }
  }, []);

  function acknowledge() {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      // Ignorieren – Hinweis verschwindet trotzdem für diese Sitzung.
    }
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="cookie-notice" role="region" aria-label="Cookie-Hinweis">
      <div className="cookie-notice-card" data-testid="notice-cookie">
        <span className="cookie-notice-icon">
          <Cookie size={18} />
        </span>
        <p className="cookie-notice-text">
          Wir nutzen ausschließlich technisch notwendige Cookies, damit die
          Anmeldung funktioniert – kein Tracking, keine Werbung. Mehr dazu in der{" "}
          <Link to="/datenschutz" className="cookie-notice-link">
            Datenschutzerklärung
          </Link>
          {" "}und im{" "}
          <Link to="/impressum" className="cookie-notice-link">
            Impressum
          </Link>
          .
        </p>
        <button
          type="button"
          onClick={acknowledge}
          className="cookie-notice-button"
          data-testid="button-cookie-ack"
        >
          Verstanden
        </button>
      </div>
    </div>
  );
}
